import { ShadcnButton } from "@components/items/display/ShadcnButton";
import TranslatedText from "@components/items/display/TranslatedText";
import TranslatedTextTemp from "@components/items/display/TranslatedTextTemp";
import { ResourcesKey } from "@modules/localizations/translate";

const SettingsRow = ({
  label,
  children,
  onEdit,
  editButtonText = "edit",
  isButtonDisabled = false,
}: {
  label: string;
  children: React.ReactNode;
  onEdit?: () => void;
  editButtonText?: string;
  isButtonDisabled?: boolean;
}) => (
  <div className="grid w-full grid-cols-3 items-center py-5">
    <TranslatedText
      text={`settings.titles.${label}` as ResourcesKey}
      className="text-black dark:text-white"
    />
    {children}
    {onEdit && (
      <ShadcnButton
        className="bg-transparent hover:bg-transparent"
        action={onEdit}
        disabled={isButtonDisabled}
      >
        <TranslatedText
          text={`settings.titles.${editButtonText}` as ResourcesKey}
          className="w-full cursor-pointer text-[15px] font-medium !text-primary hover:opacity-70 ltr:text-right rtl:text-left"
        />
      </ShadcnButton>
    )}
  </div>
);

export default SettingsRow;
